import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-search-bids',
  templateUrl: './search-bids.component.html',
  styleUrls: ['./search-bids.component.scss']
})
export class SearchBidsComponent {

}
